import {
  GetEcommerceSettingsResponse,
  RequestedFields,
  TriggerFlow,
  Error,
} from '@wix/ambassador-ecom-v1-ecommerce-settings/types';

export function hasValidationsInCart(
  ecommerceSettingsResponse: GetEcommerceSettingsResponse,
) {
  if (
    hasRequestedFieldError(
      ecommerceSettingsResponse.errors,
      RequestedFields.VALIDATIONS_SERVICE_PLUGIN,
    ) ||
    !ecommerceSettingsResponse.ecommerceSettings?.validationsServicePlugin
      ?.activeProviders
  ) {
    return true;
  }
  return ecommerceSettingsResponse.ecommerceSettings.validationsServicePlugin.activeProviders.some(
    (item) => item.triggerFlows?.some((flow) => flow === TriggerFlow.CART),
  );
}

export function hasAdditionalFees(
  ecommerceSettingsResponse: GetEcommerceSettingsResponse,
) {
  if (
    hasRequestedFieldError(
      ecommerceSettingsResponse.errors,
      RequestedFields.ADDITIONAL_FEES_SERVICE_PLUGIN,
    ) ||
    !ecommerceSettingsResponse.ecommerceSettings?.additionalFeesServicePlugin
      ?.activeProviders
  ) {
    return true;
  }

  return (
    ecommerceSettingsResponse.ecommerceSettings.additionalFeesServicePlugin
      .activeProviders.length > 0
  );
}

export function hasRequestedFieldError(
  errors: Error[] | undefined,
  expectedRequestedField: RequestedFields,
) {
  return errors?.some(
    ({ requestedField }) => requestedField === expectedRequestedField,
  );
}
